<div class="eg-alert-container" [ngClass]="'eg-alert__' + type">
  @if (showImg) {
    <img src="assets/icons/lightbulb.svg" alt="Notification" [ngClass]="'svg-to-' + type + ' eg-alert-img'" />
  }
  <span class="eg-alert-text eg-alert-wrap" [innerHTML]="message"></span>
  <ng-content></ng-content>
</div>
